/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerStreamQueryResponse, IncidentInvestigationControllerStreamPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerStream";

function getIncidentInvestigationControllerStreamUrl(id: IncidentInvestigationControllerStreamPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/incident-agent/investigations/${id}/stream` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/stream}
 */
export async function incidentInvestigationControllerStream(id: IncidentInvestigationControllerStreamPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerStreamQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentInvestigationControllerStreamUrl(id).url.toString(), ... requestConfig })  
  return res.data
}